import React from 'react'
import PropTypes from 'prop-types'
import { Input, Button } from 'antd'
import './searchTable.scss'

export function SearchTable({
  onSetSelectedKeys,
  selectedKeys,
  confirm,
  clearFilters,
  onSetRef,
  onSearch,
  onReset
}) {
  return (
    <div className="custom-filter-dropdown">
      <Input
        ref={onSetRef}
        placeholder="Search"
        value={selectedKeys[0]}
        onChange={e => onSetSelectedKeys(e.target.value ? [e.target.value] : [])}
        onPressEnter={onSearch(selectedKeys, confirm)}
      />
      <Button type="primary" onClick={onSearch(selectedKeys, confirm)}>
        Search
      </Button>
      <Button onClick={onReset(clearFilters)}>Reset</Button>
    </div>
  )
}

SearchTable.propTypes = {
  onSetSelectedKeys: PropTypes.func,
  selectedKeys: PropTypes.any,
  confirm: PropTypes.func,
  clearFilters: PropTypes.func,
  onSetRef: PropTypes.func,
  onSearch: PropTypes.func,
  onReset: PropTypes.func
}
